/**
 * @Author: Zewei
 * @Date:   2018-01-29T10:00:21+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-24T14:13:19+08:00
 */

import { DailyReport } from '../constants/daily-report-constants.js';

const initState = {
    actionStatus: false,
}

export default function dailyReports (state = initState, action) {
  switch (action.type) {
      // common
      // case DailyReport.ActionTypes.FETCHDATA:
      //     return {...state, ...action.payload};
      // case DailyReport.ActionTypes.FETCHSUCCESS:
      //     return {...state, ...action.payload};
      // case DailyReport.ActionTypes.FETCHFAILURE:
      //     return {...state, ...action.payload};
      // case DailyReport.ActionTypes.UPDATESUCCESS:
      //     return {...state, ...action.payload};
      // case DailyReport.ActionTypes.UPDATEFAILURE:
      //     return {...state, ...action.payload};
      // case DailyReport.ActionTypes.CREATESUCCESS:
      //     return {...state, ...action.payload};
      // case DailyReport.ActionTypes.CREATEFAILURE:
      //     return {...state, ...action.payload};
      // daily report
      case DailyReport.ActionTypes.INITDAILYREPORTSUCCESS:
          return { ...state, ...action.payload };
      case DailyReport.ActionTypes.EDITDAILYREPORTSUCCESS:
          return { ...state, dailyReportTemplate: action.payload.data };
      case DailyReport.ActionTypes.FETCHDAILYREPORTSUCCESS:
          return { ...state, ...action.payload };
      case DailyReport.ActionTypes.FETCHLEADERDAILYREPORTSUCCESS:
          return { ...state, ...action.payload };
      // other report
       case DailyReport.ActionTypes.FETCHREPORTSUCCESS:
           return {...state, ...action.payload};
       case DailyReport.ActionTypes.FETCHREPORTFAILURE:
           return {...state, ...action.payload};
       case DailyReport.ActionTypes.FETCHREPORTINITSUCCESS:
           return {...state, ...action.payload};
       case DailyReport.ActionTypes.FETCHREPORTINITFAILURE:
           return {...state, ...action.payload};
       case DailyReport.ActionTypes.CREATEREPORTESUCCESS:
           return {...state, ...action.payload};
       case DailyReport.ActionTypes.CREATEREPORTEFAILURE:
           return {...state, ...action.payload};
       case DailyReport.ActionTypes.FETCHUSERGROUPSUCCESS:
           return {...state, ...action.payload};
       case DailyReport.ActionTypes.FETCHUSERGROUPFAILURE:
           return {...state, ...action.payload};
       case DailyReport.ActionTypes.CREATEUSERGROUPSUCCESS:
           return {...state, ...action.payload};
       case DailyReport.ActionTypes.CREATEUSERGROUPFAILURE:
           return {...state, ...action.payload};
       case DailyReport.ActionTypes.DELETEUSERGROUPSUCCESS:
           return {...state, ...action.payload};
       case DailyReport.ActionTypes.DELETEUSERGROUPFAILURE:
           return {...state, ...action.payload};
       case DailyReport.ActionTypes.FETCHEUSERGROUPDETAILSUCCESS:
           return {...state, ...action.payload};
       case DailyReport.ActionTypes.FETCHEUSERGROUPDETAILFAILURE:
           return {...state, ...action.payload};
       case DailyReport.ActionTypes.FETCHCURRENTUSERDETAILSUCCESS:
           return {...state, ...action.payload};
       case DailyReport.ActionTypes.FETCHCURRENTUSERDETAILFAILURE:
           return {...state, ...action.payload};
       case DailyReport.ActionTypes.FETCHREPORTDETAILSUCCESS:
           return {...state, ...action.payload};
       case DailyReport.ActionTypes.FETCHREPORTDETAILFAILURE:
           return {...state, ...action.payload};
       case DailyReport.ActionTypes.EMPTY:
           return {...state, ...action.payload};
       case DailyReport.ActionTypes.DELETEREPORTSSUCCESS:
           return {...state, ...action.payload};
       case DailyReport.ActionTypes.DELETEREPORTSFAILURE:
           return {...state, ...action.payload};
       case DailyReport.ActionTypes.UPDATEUSERGROUPSUCCESS:
           return {...state, ...action.payload};
       case DailyReport.ActionTypes.UPDATEUSERGROUPFAILURE:
           return {...state, ...action.payload}; 
       case DailyReport.ActionTypes.EMPTYUSERGROUPDETAIL:
           return {...state, ...action.payload};
       //userGroupDetail
      case DailyReport.ActionTypes.FETCHUSERGROUPDETAILLISTSUCCESS:
           return {...state, ...action.payload};
       case DailyReport.ActionTypes.UPDATEUSERGROUPDETAILLISTSUCCESS:
           return {...state, ...action.payload};
      // default
      default:
          return {...state};
  }
}



// WEBPACK FOOTER //
// ./src/reducers/daily-report-reducer.js